<script>
    import Textfield from './TextField.svelte';
    import { createEventDispatcher } from 'svelte';
    import { getRandomInt } from '../utils.js';
    const dispatch = createEventDispatcher();

    export let label = "";
    export let placeholder = "placeholder";
    export let suffix = "";
    export let value = 0;
    export let defaultValue = 0;
    export let increment = 1;
    export let significantDigits = 4;
    export let max = Number.MAX_VALUE;
    export let min = -Number.MAX_VALUE;
    export let showSpinners = false;
    export let width = null;
    export let height = "32px";

    const buttonWidth = 30;

    $: text = (value ? Number(value) : 0).toPrecision(significantDigits)/1;

    function onChange() {
        dispatch('change', {});
    }

    function parse(expr) {
      if (!expr) return 0;
      expr = expr.replace(",", ".");
      while (expr.match(/\((.*?)\)/))
        expr = expr.replace(/\((.*?)\)/, (match, g1, offset, string) => parse(g1));
      while (expr.match(/(-*\d+\.*\d*)\/(-*\d+\.*\d*)/))
        expr = expr.replace(/(-*\d+\.*\d*)\/(-*\d+\.*\d*)/, (match, g1, g2, offset, string) => g1/g2);
      while (expr.match(/(-*\d+\.*\d*)\*(-*\d+\.*\d*)/))
        expr = expr.replace(/(-*\d+\.*\d*)\*(-*\d+\.*\d*)/, (match, g1, g2, offset, string) => g1*g2);
      while (expr.match(/(-*\d+\.*\d*)-(-*\d+\.*\d*)/))		
        expr = expr.replace(/(-*\d+\.*\d*)-(-*\d+\.*\d*)/, (match, g1, g2, offset, string) => parseFloat(g1)-parseFloat(g2));
      while (expr.match(/(-*\d+\.*\d*)\+(-*\d+\.*\d*)/))
        expr = expr.replace(/(-*\d+\.*\d*)\+(-*\d+\.*\d*)/, (match, g1, g2, offset, string) => parseFloat(g1)+parseFloat(g2));
      return expr;
    }

    function getNumber() {
        let temp = text.toString().replace(/[^0-9,.\-+*/()]/, "");
        try { temp = parse(temp); }
        catch { temp = text; }
        if (typeof temp === "string") {    
            const match = temp.match(/-?\d* *\d([,.]\d)*/);
            if (match && match.length)
            {
                const numberText = match[0].replace(',', '.');
                return parseFloat(numberText);
            }
            else
                return defaultValue;
        }
        return temp;
    }

    function incrementValue() {
        let number = getNumber();
        commitNumber(number + increment);
    }

    function decrementValue() {
        let number = getNumber();
        commitNumber(number - increment);
    }

    function commitNumber(number) {
        if (number < min) number = min;
        else if (number > max) number = max;
        
        // trick to make sure it always updates, 
        // because if user entered 1000abc and the number was 1000 
        // the parsed number will still be 1000 and TextField is not updated.
        value = getRandomInt(1000);
        
        value = number;

        onChange();
    }

    function validate() {
        let number = getNumber();
        commitNumber(number);
    }

    function handleKey(e) {
        if (e.key === "ArrowUp") {
            incrementValue();
            e.preventDefault();
        }
        else if (e.key === "ArrowDown") {
            decrementValue();
            e.preventDefault();
        }
        else if (e.key === "Enter") {
            validate();
        }
    }
</script>

<div class="numericInput" style="width: {width}; grid-template-columns: {showSpinners ? "auto auto auto" : "auto"};">
    <Textfield bind:text={text} {label} {suffix} {placeholder} inputmode="decimal" pattern="[0-9]+([\.,][0-9]+)?" {height}
        on:lostFocus={() => validate()} on:keydown={(e) => handleKey(e)} on:change={() => onChange()}>
    </Textfield>
    {#if showSpinners}
        <button class:bottomAlign={label.length} on:click={() => decrementValue()} style="width: {buttonWidth}px; height: {height}" tabindex=-1>
            <svg height=10 width=10>
                <line x1=0 y1=5 x2=10 y2=5 />
            </svg>
        </button>
        <button class:bottomAlign={label.length} on:click={() => incrementValue()} style="width: {buttonWidth}px; height: {height}" tabindex=-1>
            <svg height=10 width=10>
                <line x1=0 y1=5 x2=10 y2=5 />
                <line x1=5 y1=0 x2=5 y2=10 />
            </svg>
        </button>
    {/if}
</div>

<style>
    .numericInput {
        display: grid;
        grid-template-rows: auto;
    }

    button {
        margin: 0;
        border-radius: var(--border-radius)px;
    }
   
    .bottomAlign {
        align-self: end;
    }

    line {
        stroke: #666; 
        stroke-width: 2px;
    }
</style>